import LockPage from 'src/kiosks/lock';

export default LockPage;
